var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fetch-json',{attrs:{"url":_vm.url},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var documents = ref.json;
var loading = ref.loading;
return [(!loading)?_c('div',[_vm._t("default",null,{"documents":documents})],2):_vm._e()]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }